import Frontend from "layouts/Frontend/Frontend.jsx";
import { Roles } from "../constants/Roles";
import Signup from "../components/FrontEnd/Signup";
const FrontEndRoutes = [
  //   {
  //     path: "/Photo_Uploader",
  //     name: "Photo Uploader",
  //     component: PhotoUploader,
  //     showMenu: true,
  //     number: 5,
  //     navIcon: "flaticon-upload"
  //   },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
    showMenu: true,
    number: 3,
    navClass: "loginIcon",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Frontend,
    auth: true,
    role: [...Object.values(Roles)],
    // role: [Roles.SUPER_ADMIN],
    navIcon: "flaticon-home"
  },
  {
    path: "/Home",
    name: "Home",
    component: Frontend,
    showMenu: false,
    number: 0,
  },
  {
    path: "/",
    name: "Home",
    component: Frontend,
    showMenu: false,
    number: 0,
  },
  {
    path: "/logout",
    name: "Logout",
    component: "",
    auth: true,
    role: [Roles.SUPER_ADMIN],
    navIcon: "flaticon-log-out"
  },

];
export default FrontEndRoutes;



// WEBPACK FOOTER //
// ./src/routes/FrontEndRoutes.jsx